import { useEffect } from "react";

/** Tiny redirect to the standalone "Cena con Carlos" landing HTML. */
const CenaConCarlosRedirect = () => {
  useEffect(() => {
    window.location.replace("/cenaconcarlos.html");
  }, []);
  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "#0D1B2A",
      color: "#C9A84C",
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      letterSpacing: "2px",
      textTransform: "uppercase",
    }}>
      Cargando…
    </div>
  );
};

export default CenaConCarlosRedirect;
